import React, { useState, useEffect } from "react";
import { Typography, Grid, Box, useMediaQuery, useTheme, Fade } from "@mui/material";
import { GradientText } from "../dashboard/Gradient";
import { useThemeMode } from "@/colors";


const Title = ({ center, spacing, titleSize }: { center?: boolean, spacing?: string, titleSize: string }) => {
  const theme = useTheme();
  const { colors } = useThemeMode();
  const isSmall = useMediaQuery("(max-width: 1000px)");
  const isReallySmall = useMediaQuery("(max-width: 500px)");
  const fontSize = titleSize ? titleSize : isSmall ? "3.5rem" : "4.5rem";
  
  // Animation state for cycling text
  const words = ["affordable", "bespoke", "tailored", "premium"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false);
      
      setTimeout(() => {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        setFadeIn(true);
      }, 1000); // Half of the fade transition duration
    }, 3000); // Change word every 5 seconds

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <Grid item xs={12} style={{ marginTop: "0", }}>
      <Box display="flex" alignItems="center" justifySelf="center">
        <Typography
          variant="h1"
          fontWeight={500}
          style={{
            fontSize,
            display: "inline",
            color: theme.palette.mode === "dark" ? colors.text.brand.darkest : colors.text.neutral.dark,
            paddingBottom: spacing || "16px",
            fontWeight: 550,
            lineHeight: "56px",
            // letterSpacing: "2px",
          }}
        >
          {isSmall ? (
            <>
              The&nbsp;<span style={{ letterSpacing: "3px" }}>fi</span>rst
              <br/>
              <Box component="span" style={{ display: "inline-block", width: isReallySmall ? "300px" : "470px", textAlign: isSmall ? "center" : "left" }}>
                <Fade in={fadeIn} timeout={900}>
                  <GradientText variant="h1" display="inline" style={{ fontSize }}>
                    {words[currentWordIndex]}
                  </GradientText>
                </Fade>
              </Box>
              <br/> map creator
            </>
          ) : (
            <>
              <Fade in={fadeIn} timeout={900}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  The&nbsp;<span style={{ letterSpacing: "3px" }}>fi</span>rst
                  <Box component="span" style={{
                    display: "inline-block", 
                    textAlign: "left",
                  }}>
                    <GradientText variant="h1" display="inline" style={{ fontSize, marginLeft: "16px" }}>
                      {words[currentWordIndex]}
                    </GradientText>
                  </Box>
                </Box>
              </Fade>
              map creator
            </>
          )}
        </Typography>
      </Box>
    </Grid>
  );
};

export default Title;
